import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import InputOTA from "~/features/base/components/forms/ota/InputOTA";

interface SemanticVersion {
  major: number;
  minor: number;
  patch: number;
}

interface SemanticVersionInputFormItemProps {
  label?: string;
  classNameInputField?: string;
  classNameClearButton?: string;
  value: SemanticVersion;
  isClearable?: boolean;
  onChange: (value: SemanticVersion | undefined) => void;
}

const SemanticVersionInputFormItem: React.FC<
  SemanticVersionInputFormItemProps
> = ({
  label = "intl-msg:baseSoftwareVersion",
  value = { major: 0, minor: 0, patch: 0 },
  isClearable = false,
  onChange,
}) => {
  const handleFieldChange = useCallback(
    (field: keyof SemanticVersion) =>
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseInt(e.target.value) || 0;
        onChange({ ...value, [field]: newValue });
      },
    [value, onChange],
  );

  const handleClear = useCallback(() => onChange(undefined), [onChange]);

  return (
    <div>
      <label className='control-label'>
        <FormattedMessage id={label} />
      </label>
      <div className="display-flex flex-row gap-5">
        <div className="width-30pct">
          <InputOTA
            type="text"
            className="form-control"
            value={value.major}
            placeholder="Major"
            onChange={handleFieldChange("major")}
          />
        </div>
        <div className="width-30pct">
          <InputOTA
            type="text"
            className="form-control"
            value={value.minor}
            placeholder="Minor"
            onChange={handleFieldChange("minor")}
          />
        </div>
        <div className="width-30pct">
          <InputOTA
            type="text"
            className="form-control"
            value={value.patch}
            placeholder="Patch"
            onChange={handleFieldChange("patch")}
          />
        </div>
        {isClearable && (
          <div className={""}>
            <FormattedMessage id="intl-msg:clear">
              {(clearMessage) => (
                <button
                  type="button"
                  title={clearMessage}
                  className="btn btn-muted btn-icon-only"
                  onClick={handleClear}
                >
                  <span className="rioglyph rioglyph-remove-sign" />
                </button>
              )}
            </FormattedMessage>
          </div>
        )}
      </div>
    </div>
  );
};

export default SemanticVersionInputFormItem;
